import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import CallButton from "@/components/CallButton";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import HebergementsPage from "@/pages/HebergementsPage";
import RandonneesPage from "@/pages/RandonneesPage";
import PluiePage from "@/pages/PluiePage";
import SejourIdealPage from "@/pages/SejourIdealPage";
import PlanPage from "@/pages/PlanPage";
import LegalPage from "@/pages/LegalPage";

function Shell() {
  const lenisRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true, force: true });
  }, [location.pathname]);

  useEffect(() => {
    const titles = {
      "/": "Camping Aveyron 4 étoiles au bord du lac de Bannac | Réservation en ligne — Le Lac aux Oiseaux, Martiel",
      "/hebergements": "Location mobil-home Aveyron avec climatisation · Lodges insolites | Camping Le Lac aux Oiseaux",
      "/randonnees": "Les 7 plus belles randonnées autour du lac de Bannac | Camping Martiel, Aveyron",
      "/que-faire-quand-il-pleut": "Que faire en Aveyron quand il pleut ? 4 idées à moins de 40 min de Martiel",
      "/sejour-ideal": "Mon séjour idéal en Aveyron : une semaine au camping Le Lac aux Oiseaux",
      "/mentions-legales": "Mentions légales | Camping Le Lac aux Oiseaux — Martiel, Aveyron",
      "/politique-confidentialite": "Politique de confidentialité | Camping Le Lac aux Oiseaux — Martiel, Aveyron",
    };
    document.title = titles[location.pathname] || titles["/"];
  }, [location.pathname]);

  const scrollTo = (target) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => lenisRef.current?.scrollTo(target, { offset: -90, duration: 1.2 }), 450);
      return;
    }
    lenisRef.current?.scrollTo(target, { offset: -90, duration: 1.5 });
  };

  return (
    <div className="bg-sand text-ink font-body overflow-x-clip">
      <Toaster position="top-center" richColors />
      <Navbar scrollTo={scrollTo} />
      <CallButton />
      <Routes>
        <Route path="/" element={<HomePage scrollTo={scrollTo} />} />
        <Route path="/hebergements" element={<HebergementsPage />} />
        <Route path="/randonnees" element={<RandonneesPage />} />
        <Route path="/que-faire-quand-il-pleut" element={<PluiePage />} />
        <Route path="/sejour-ideal" element={<SejourIdealPage />} />
        <Route path="/plan-du-camping" element={<PlanPage />} />
        <Route path="/mentions-legales" element={<LegalPage pageKey="mentions-legales" />} />
        <Route path="/politique-confidentialite" element={<LegalPage pageKey="politique-confidentialite" />} />
      </Routes>
      <Footer scrollTo={scrollTo} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
